import { z } from "zod";

export const initiateMerchantSchema = z.object({
  publicID: z.string(),
  amount: z.number(),
  bankAccountID: z.number().optional(),
  paypointID: z.string().optional(),
});

export type InitiatePaymentFormData = z.infer<typeof initiateMerchantSchema>;
